export default "__VITE_ASSET__80c1b511__"